import { render } from "./px-questionary-placeholder.vue?vue&type=template&id=38292218&scoped=true&ts=true"
import script from "./px-questionary-placeholder.vue?vue&type=script&lang=ts"
export * from "./px-questionary-placeholder.vue?vue&type=script&lang=ts"

import "./px-questionary-placeholder.vue?vue&type=style&index=0&id=38292218&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38292218"]])

export default __exports__